import React from 'react';
import DepthProfileView from './DepthProfileView';
import DepthMapView from './DepthMapView';

/**
 * Renderiza el bloque DepthAnalyticsView de SCAPP V2.
 *
 * @param {object} props
 * @param {object} props.v - Modelo de presentación y callbacks del panel.
 * @returns {React.ReactNode} Bloque visual sin estado local.
 */
export default function DepthAnalyticsView({
  v
}) {
  return v.viewDep ? React.createElement(React.Fragment, null, React.createElement("div", {
    style: {
      "flex": "1",
      "minHeight": "0",
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.925926vh"
    }
  }, v.text("\n        "), React.createElement("div", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "1.111111vh"
    }
  }, React.createElement("h2", {
    style: {
      "margin": "0",
      "fontSize": "1.481481vh",
      "fontWeight": "600"
    }
  }, v.text("Profundidad")), React.createElement("span", {
    style: {
      "fontSize": "1.111111vh",
      "color": "#8793a6",
      "whiteSpace": "nowrap",
      "overflow": "hidden",
      "textOverflow": "ellipsis",
      "minWidth": "0"
    }
  }, v.text("estratos de 1 m")), React.createElement("div", {
    "title": "Cobertura: tiempo con dato de winche",
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.555556vh",
      "flex": "none",
      "whiteSpace": "nowrap"
    }
  }, React.createElement("div", {
    style: {
      "width": "0.9375vw",
      "height": "1.666667vh",
      "borderRadius": "50%",
      "background": "conic-gradient(" + v.depWin.covC + " " + v.depWin.covDeg + ", #1c2636 0)",
      "display": "flex",
      "alignItems": "center",
      "justifyContent": "center"
    }
  }, React.createElement("div", {
    style: {
      "width": "0.625vw",
      "height": "1.111111vh",
      "borderRadius": "50%",
      "background": "#0e1b2e"
    }
  }, null)), React.createElement("span", {
    style: {
      "font": "600 1.111111vh 'IBM Plex Mono',monospace",
      "color": v.depWin.covC
    }
  }, v.text(v.depWin.cov)), React.createElement("span", {
    style: {
      "fontSize": "1.018519vh",
      "color": "#8793a6"
    }
  }, v.text("con dato"))), React.createElement("button", {
    "onClick": v.backDet,
    style: {
      "marginLeft": "auto",
      "background": "#16213a",
      "border": "0.092593vh solid oklch(0.78 0.12 250)",
      "color": "#e4e9f0",
      "borderRadius": "0.555556vh",
      "padding": "0.37037vh 0.925926vh",
      "cursor": "pointer",
      "font": "1.111111vh 'IBM Plex Sans',sans-serif",
      "whiteSpace": "nowrap"
    }
  }, v.text("‹ Detalle diario"))), v.text("\n  "), React.createElement("div", {
    style: {
      "flex": "1",
      "minHeight": "0",
      "display": "grid",
      "gridTemplateColumns": "14.583333vw minmax(0,1fr)",
      "gap": "1.481481vh"
    }
  }, v.text("\n    "), React.createElement("aside", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "gap": "1.296296vh",
      "minHeight": "0",
      "overflow": "auto",
      "paddingRight": "0.833333vw",
      "borderRight": "0.052083vw solid rgba(46,179,238,0.12)"
    }
  }, v.text("\n      \n      "), React.createElement("div", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.555556vh"
    }
  }, React.createElement("div", {
    style: {
      "fontSize": "1.018519vh",
      "color": "#8793a6",
      "letterSpacing": "0.04em",
      "textTransform": "uppercase"
    }
  }, v.text("Alcance")), React.createElement("div", {
    style: {
      "display": "flex",
      "flexWrap": "wrap",
      "gap": "0.185185vh",
      "background": "rgba(3,10,22,0.6)",
      "border": "0.092593vh solid rgba(46,179,238,0.14)",
      "borderRadius": "0.555556vh",
      "padding": "0.185185vh"
    }
  }, (v.depScope || []).map((m, index36) => React.createElement(React.Fragment, {
    key: index36
  }, React.createElement("button", {
    "onClick": m.onClick,
    style: {
      "flex": "1",
      "border": "0",
      "borderRadius": "0.37037vh",
      "padding": "0.37037vh 0.740741vh",
      "font": "1.111111vh 'IBM Plex Sans',sans-serif",
      "cursor": "pointer",
      "background": m.bg,
      "color": m.color,
      "fontWeight": m.fw,
      "whiteSpace": "nowrap"
    }
  }, v.text(m.label)))))), v.text("\n      "), React.createElement("div", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.555556vh"
    }
  }, React.createElement("div", {
    style: {
      "fontSize": "1.018519vh",
      "color": "#8793a6",
      "letterSpacing": "0.04em",
      "textTransform": "uppercase"
    }
  }, v.text("Período")), React.createElement("div", {
    style: {
      "display": "flex",
      "flexWrap": "wrap",
      "gap": "0.185185vh",
      "background": "rgba(3,10,22,0.6)",
      "border": "0.092593vh solid rgba(46,179,238,0.14)",
      "borderRadius": "0.555556vh",
      "padding": "0.185185vh"
    }
  }, (v.depPer || []).map((m, index37) => React.createElement(React.Fragment, {
    key: index37
  }, React.createElement("button", {
    "onClick": m.onClick,
    style: {
      "flex": "1",
      "border": "0",
      "borderRadius": "0.37037vh",
      "padding": "0.37037vh 0.740741vh",
      "font": "1.111111vh 'IBM Plex Sans',sans-serif",
      "cursor": "pointer",
      "background": m.bg,
      "color": m.color,
      "fontWeight": m.fw,
      "whiteSpace": "nowrap"
    }
  }, v.text(m.label)))))), v.text("\n      "), React.createElement("div", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.555556vh"
    }
  }, React.createElement("div", {
    style: {
      "fontSize": "1.018519vh",
      "color": "#8793a6",
      "letterSpacing": "0.04em",
      "textTransform": "uppercase"
    }
  }, v.text("Métrica")), React.createElement("div", {
    style: {
      "display": "flex",
      "flexWrap": "wrap",
      "gap": "0.185185vh",
      "background": "rgba(3,10,22,0.6)",
      "border": "0.092593vh solid rgba(46,179,238,0.14)",
      "borderRadius": "0.555556vh",
      "padding": "0.185185vh"
    }
  }, (v.depMet || []).map((m, index38) => React.createElement(React.Fragment, {
    key: index38
  }, React.createElement("button", {
    "onClick": m.onClick,
    style: {
      "flex": "1",
      "border": "0",
      "borderRadius": "0.37037vh",
      "padding": "0.37037vh 0.740741vh",
      "font": "1.111111vh 'IBM Plex Sans',sans-serif",
      "cursor": "pointer",
      "background": m.bg,
      "color": m.color,
      "fontWeight": m.fw,
      "whiteSpace": "nowrap"
    }
  }, v.text(m.label)))))), v.text("\n      "), React.createElement("div", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.555556vh",
      "paddingTop": "1.111111vh",
      "borderTop": "0.092593vh solid rgba(46,179,238,0.12)"
    }
  }, React.createElement("div", {
    style: {
      "fontSize": "1.018519vh",
      "color": "#8793a6",
      "letterSpacing": "0.04em",
      "textTransform": "uppercase"
    }
  }, v.text("Estrato crítico")), React.createElement("div", {
    style: {
      "font": "600 2.407407vh 'IBM Plex Mono',monospace",
      "color": "oklch(0.72 0.17 25)"
    }
  }, v.text(v.depIns.lab)), React.createElement("div", {
    style: {
      "fontSize": "1.111111vh",
      "lineHeight": "1.5",
      "color": "#b8c1ce",
      "textWrap": "pretty"
    }
  }, v.text(v.depIns.txt))), v.text("\n      "), React.createElement("div", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.37037vh",
      "paddingTop": "1.111111vh",
      "borderTop": "0.092593vh solid rgba(46,179,238,0.12)"
    }
  }, React.createElement("div", {
    style: {
      "fontSize": "1.018519vh",
      "color": "#8793a6",
      "letterSpacing": "0.04em",
      "textTransform": "uppercase"
    }
  }, v.text("Tiempo")), (v.depWin.tiempo || []).map((k, index39) => React.createElement(React.Fragment, {
    key: index39
  }, React.createElement("div", {
    style: {
      "display": "flex",
      "justifyContent": "space-between",
      "gap": "0.925926vh",
      "fontSize": "1.111111vh",
      "lineHeight": "1.851852vh"
    }
  }, React.createElement("span", {
    style: {
      "color": "#b8c1ce",
      "whiteSpace": "nowrap"
    }
  }, v.text(k.l)), React.createElement("span", {
    style: {
      "font": "600 1.111111vh 'IBM Plex Mono',monospace",
      "color": k.c,
      "whiteSpace": "nowrap"
    }
  }, v.text(k.v)))))), v.text("\n      "), React.createElement("div", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.37037vh",
      "paddingTop": "1.111111vh",
      "borderTop": "0.092593vh solid rgba(46,179,238,0.12)"
    }
  }, React.createElement("div", {
    style: {
      "fontSize": "1.018519vh",
      "color": "#8793a6",
      "letterSpacing": "0.04em",
      "textTransform": "uppercase"
    }
  }, v.text("Winche")), React.createElement("div", {
    style: {
      "display": "flex",
      "justifyContent": "space-between",
      "gap": "0.925926vh",
      "fontSize": "1.111111vh",
      "lineHeight": "1.851852vh"
    }
  }, React.createElement("span", {
    style: {
      "color": "#b8c1ce"
    }
  }, v.text("Reposicionamientos")), React.createElement("span", {
    style: {
      "font": "600 1.111111vh 'IBM Plex Mono',monospace",
      "color": "#e4e9f0"
    }
  }, v.text(v.depWin.rep))), React.createElement("div", {
    style: {
      "height": "0.555556vh",
      "borderRadius": "0.277778vh",
      "background": "#5a667a",
      "overflow": "hidden",
      "display": "flex"
    }
  }, React.createElement("div", {
    style: {
      "width": v.depWin.opW,
      "background": "oklch(0.7 0.18 40)"
    }
  }, null)), React.createElement("div", {
    style: {
      "display": "flex",
      "justifyContent": "space-between",
      "fontSize": "1.018519vh",
      "paddingBottom": "0.37037vh"
    }
  }, React.createElement("span", {
    style: {
      "color": "oklch(0.7 0.18 40)"
    }
  }, v.text(v.depWin.opL)), React.createElement("span", {
    style: {
      "color": "#8793a6"
    }
  }, v.text(v.depWin.ruL))), (v.depWin.winche || []).map((k, index40) => React.createElement(React.Fragment, {
    key: index40
  }, React.createElement("div", {
    style: {
      "display": "flex",
      "justifyContent": "space-between",
      "gap": "0.925926vh",
      "fontSize": "1.111111vh",
      "lineHeight": "1.851852vh"
    }
  }, React.createElement("span", {
    style: {
      "color": "#b8c1ce",
      "whiteSpace": "nowrap"
    }
  }, v.text(k.l)), React.createElement("span", {
    style: {
      "font": "600 1.111111vh 'IBM Plex Mono',monospace",
      "color": k.c,
      "whiteSpace": "nowrap"
    }
  }, v.text(k.v)))))), v.text("\n      "), React.createElement("div", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.37037vh",
      "paddingTop": "1.111111vh",
      "borderTop": "0.092593vh solid rgba(46,179,238,0.12)"
    }
  }, React.createElement("div", {
    style: {
      "fontSize": "1.018519vh",
      "color": "#8793a6",
      "letterSpacing": "0.04em",
      "textTransform": "uppercase"
    }
  }, v.text("Alarmas")), (v.depWin.alarmas || []).map((k, index41) => React.createElement(React.Fragment, {
    key: index41
  }, React.createElement("div", {
    style: {
      "display": "flex",
      "justifyContent": "space-between",
      "gap": "0.925926vh",
      "fontSize": "1.111111vh",
      "lineHeight": "1.851852vh"
    }
  }, React.createElement("span", {
    style: {
      "color": "#b8c1ce",
      "whiteSpace": "nowrap"
    }
  }, v.text(k.l)), React.createElement("span", {
    style: {
      "font": "600 1.111111vh 'IBM Plex Mono',monospace",
      "color": k.c,
      "whiteSpace": "nowrap"
    }
  }, v.text(k.v)))))), v.text("\n      "), v.depIsMap ? React.createElement(React.Fragment, null, React.createElement("div", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.555556vh",
      "marginTop": "auto"
    }
  }, React.createElement("div", {
    style: {
      "fontSize": "1.018519vh",
      "color": "#8793a6",
      "letterSpacing": "0.04em",
      "textTransform": "uppercase"
    }
  }, v.text("Escala")), React.createElement("div", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.740741vh",
      "font": "1.018519vh 'IBM Plex Mono',monospace",
      "color": "#8793a6"
    }
  }, React.createElement("span", {
    style: {
      "whiteSpace": "nowrap"
    }
  }, v.text(v.depMin)), React.createElement("div", {
    style: {
      "flex": "1",
      "display": "flex",
      "height": "0.740741vh",
      "borderRadius": "0.185185vh",
      "overflow": "hidden"
    }
  }, (v.depLeg || []).map((g, index42) => React.createElement(React.Fragment, {
    key: index42
  }, React.createElement("div", {
    style: {
      "flex": "1",
      "background": g.c
    }
  }, null)))), React.createElement("span", {
    style: {
      "whiteSpace": "nowrap"
    }
  }, v.text(v.depMax))), React.createElement("div", {
    style: {
      "display": "flex",
      "flexWrap": "wrap",
      "gap": "0.555556vh 1.111111vh",
      "fontSize": "1.018519vh",
      "color": "#5a667a"
    }
  }, React.createElement("span", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.37037vh",
      "whiteSpace": "nowrap"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.520833vw",
      "height": "0.925926vh",
      "borderRadius": "0.185185vh",
      "background": "rgba(46,179,238,0.07)",
      "border": "0.092593vh solid rgba(46,179,238,0.2)"
    }
  }, null), v.text("Cero")), React.createElement("span", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.37037vh",
      "whiteSpace": "nowrap"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.520833vw",
      "height": "0.925926vh",
      "borderRadius": "0.185185vh",
      "border": "0.092593vh dashed #2a3446"
    }
  }, null), v.text("Sin paso")), React.createElement("span", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.37037vh",
      "whiteSpace": "nowrap"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.520833vw",
      "height": "0.925926vh",
      "borderRadius": "0.185185vh",
      "background": "#0a1220",
      "border": "0.092593vh solid #1c2636"
    }
  }, null), v.text("Ayuno"))))) : null, v.text("\n    ")), v.text("\n    "), React.createElement("section", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.925926vh",
      "minHeight": "0"
    }
  }, v.text("\n      "), React.createElement("div", {
    style: {
      "display": "flex",
      "alignItems": "baseline",
      "gap": "1.111111vh",
      "minWidth": "0"
    }
  }, React.createElement("h2", {
    style: {
      "margin": "0",
      "fontSize": "1.388889vh",
      "fontWeight": "600",
      "whiteSpace": "nowrap"
    }
  }, v.text(v.depTitle)), React.createElement("span", {
    style: {
      "fontSize": "1.111111vh",
      "color": "#8793a6",
      "whiteSpace": "nowrap"
    }
  }, v.text(v.depSub)), React.createElement("div", {
    style: {
      "marginLeft": "auto",
      "display": "flex",
      "gap": "0.185185vh",
      "background": "rgba(3,10,22,0.6)",
      "border": "0.092593vh solid rgba(46,179,238,0.14)",
      "borderRadius": "0.555556vh",
      "padding": "0.185185vh",
      "flex": "none"
    }
  }, (v.depModes || []).map((m, index43) => React.createElement(React.Fragment, {
    key: index43
  }, React.createElement("button", {
    "onClick": m.onClick,
    style: {
      "border": "0",
      "borderRadius": "0.37037vh",
      "padding": "0.277778vh 1.111111vh",
      "font": "1.111111vh 'IBM Plex Sans',sans-serif",
      "cursor": "pointer",
      "background": m.bg,
      "color": m.color
    }
  }, v.text(m.label)))))), v.text("\n      "), React.createElement(DepthProfileView, {
    v
  }), v.text("\n      "), v.depIsTab ? React.createElement(React.Fragment, null, React.createElement("div", {
    style: {
      "flex": "1",
      "minHeight": "0",
      "overflow": "auto",
      "display": "flex",
      "flexDirection": "column"
    }
  }, React.createElement("div", {
    style: {
      "display": "grid",
      "gridTemplateColumns": "3.333333vw repeat(2,minmax(0,1.3fr)) repeat(4,minmax(0,1fr))",
      "gap": "0.925926vh",
      "padding": "0.740741vh 0.925926vh",
      "borderBottom": "0.092593vh solid rgba(46,179,238,0.18)",
      "position": "sticky",
      "top": "0",
      "background": "rgba(10,20,36,0.96)"
    }
  }, (v.depTHead || []).map((h, index47) => React.createElement(React.Fragment, {
    key: index47
  }, React.createElement("button", {
    "onClick": h.onClick,
    style: {
      "background": "transparent",
      "border": "0",
      "padding": "0",
      "cursor": "pointer",
      "textAlign": h.al,
      "font": "600 1.018519vh 'IBM Plex Sans',sans-serif",
      "letterSpacing": "0.04em",
      "textTransform": "uppercase",
      "color": h.c,
      "whiteSpace": "nowrap"
    }
  }, v.text(h.l))))), (v.depTable || []).map((x, index48) => React.createElement(React.Fragment, {
    key: index48
  }, React.createElement("div", {
    style: {
      "display": "grid",
      "gridTemplateColumns": "3.333333vw repeat(2,minmax(0,1.3fr)) repeat(4,minmax(0,1fr))",
      "gap": "0.925926vh",
      "padding": "0.555556vh 0.925926vh",
      "borderBottom": "0.092593vh solid rgba(46,179,238,0.07)",
      "background": x.bg,
      "font": "1.111111vh 'IBM Plex Mono',monospace",
      "color": "#b8c1ce"
    }
  }, React.createElement("span", {
    style: {
      "color": x.labC,
      "fontWeight": "600",
      "whiteSpace": "nowrap"
    }
  }, v.text(x.lab)), React.createElement("span", {
    style: {
      "textAlign": "right",
      "color": "oklch(0.72 0.14 55)",
      "whiteSpace": "nowrap"
    }
  }, v.text(x.feed)), React.createElement("span", {
    style: {
      "textAlign": "right",
      "whiteSpace": "nowrap"
    }
  }, v.text(x.idle)), React.createElement("span", {
    style: {
      "textAlign": "right",
      "color": x.alC
    }
  }, v.text(x.al)), React.createElement("span", {
    style: {
      "textAlign": "right"
    }
  }, v.text(x.ppa)), React.createElement("span", {
    style: {
      "textAlign": "right"
    }
  }, v.text(x.kg)), React.createElement("span", {
    style: {
      "textAlign": "right"
    }
  }, v.text(x.ppm))))), React.createElement("div", {
    style: {
      "padding": "0.740741vh 1.111111vh",
      "fontSize": "1.018519vh",
      "color": "#5a667a"
    }
  }, v.text(v.depTabN)))) : null, v.text("\n      "), React.createElement(DepthMapView, {
    v
  }), v.text("\n    ")), v.text("\n  ")), v.text("\n        "))) : null;
}
